import axios from 'axios'
import {notification} from 'ant-design-vue';

const baseUrl = process.env.BASE_URL

// create an axios instance
const service = axios.create({
    baseURL: baseUrl, // api 的 base_url
    timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // Do something before request is sent
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        return config
    },
    error => {
        // Do something with request error
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => response,
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
        // response => {
        //   const res = response.data
        //   if (res.code !== 20000) {
        //     Message({
        //       message: res.message,
        //       type: 'error',
        //       duration: 5 * 1000
        //     })
        //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
        //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        //       // 请自行在引入 MessageBox
        //       // import { Message, MessageBox } from 'element-ui'
        //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        //         confirmButtonText: '重新登录',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //       }).then(() => {
        //         store.dispatch('FedLogOut').then(() => {
        //           location.reload() // 为了重新实例化vue-router对象 避免bug
        //         })
        //       })
        //     }
        //     return Promise.reject('error')
        //   } else {
        //     return response.data
        //   }
        // },
    error => {
        if (error && error.response && error.response.status && error.response.status === 401) {
            const redirect = error.response.headers['X-CAS-REDIRECT'] || 'login';
            window.location.href = redirect
            return Promise.resolve(null)
        } else if (error && error.response && error.response.status && error.response.status === 403) {
            // 尝试优化：http get 不弹出提示
            if (error.response.data && error.response.data['method'] !== 'GET') {
                notification.error({
                    message: '错误',
                    description: '您的权限不足，暂时无法访问该资源，请联系管理员！',
                })
            }
        } else {
            let msg = '系统异常，请稍后尝试或联系管理员！';
            if (error.response.data) {
                msg = error.response.data['retmsg'] || error.response.data['message'] || error.response.data['error'];
            }
            notification['error']({
                message: '操作失败',
                description: msg,
            });
        }
        return Promise.reject(error)
    }
)

export default service
